import React from 'react';
import PropTypes from 'prop-types';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { createIconComponent } from 'uikit/icons';

import { Markdown } from 'uikit/content';

import styles from '../styles/formFieldNotice.module.scss';

const FormFieldNotice = ({ content, hasMarkdownText = false, hasNotice = false }) => {
  if (!hasNotice || !content) return null;
  return (
    <div className={styles.element}>
      <div className={styles.icon}>
        {createIconComponent({ icon: <InfoOutlinedIcon />, size: 12 })}
      </div>
      {hasMarkdownText ? (
        <Markdown className={styles.content} content={content} />
      ) : (
        <div className={styles.content}>{content}</div>
      )}
    </div>
  );
};

FormFieldNotice.propTypes = {
  content: PropTypes.node,
  hasMarkdownText: PropTypes.bool,
  hasNotice: PropTypes.bool,
};

export { FormFieldNotice as FormFieldNoticeStorybook };
export default React.memo(FormFieldNotice);
